export default __webpack_public_path__ + "static/media/icon_wd.f3775b32.svg";